
function changeMsg(element) {

let cartNote = document.querySelector('.Cart__NoteContainer #cart-note');
  
  let inputJoyasDiamantes = document.querySelector('#pedido_joya_diamantes');
  let inputNombreDestinatorio = document.querySelector('#nombre_completo');
  let inputEsRegalo = document.querySelector('#pedido_joya_regalo');
  let inputBolsaRegalo = document.querySelector('#bolsa_regalo');
  let inputMessage = document.querySelector('textarea[name=Mensaje]');
  let inputObservaciones = document.querySelector('textarea[name=Observaciones]');
  
  messageContent = 
    `${inputJoyasDiamantes.name}: ${inputJoyasDiamantes.checked ? "Si": "No"}
    \n${inputNombreDestinatorio.name}: ${inputNombreDestinatorio.value}
    \n${inputEsRegalo.name}: ${inputEsRegalo.checked ? "Si": "No"}
    \n${inputBolsaRegalo.name}: ${inputBolsaRegalo.checked ? "Si": "No"}
    \n${inputMessage.name}: ${inputMessage.value}
    \n${inputObservaciones.name}: ${inputObservaciones.value}`;  
  if (element.type == 'checkbox') {
    let AllParents = document.querySelectorAll(`.note_cart_form-item[data-parent="${element.id}"]`);
    if(AllParents.length > 0){
      AllParents.forEach(item =>{
        if(element.checked){
          item.classList.remove('hidden--custom');
        }else{
          item.classList.add('hidden--custom');
        }
      });
    }
  }
  cartNote.value = messageContent;
actualizarNota(messageContent);
}


function actualizarNota(nota) {
  fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            note: nota
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        });  
  
}
